// extracted by mini-css-extract-plugin
export default {"gridWrapper":"gridStyles_gridWrapper__6Mrn7","grid":"gridStyles_grid__GC3lQ"};